import { PROVIDER_SOURCE_LIST } from '../../constants/quote';
import { formatCommonDateStr } from '../../utils/time';
export var handlePolicyListItemData = function handlePolicyListItemData(policyItem) {
  var _PROVIDER_SOURCE_LIST;

  var _ref = policyItem || {},
      providerCode = _ref.providerCode,
      policyNumber = _ref.policyNumber,
      activeDate = _ref.activeDate,
      expirationDate = _ref.expirationDate,
      createdAt = _ref.createdAt;

  var _ref2 = (policyItem === null || policyItem === void 0 ? void 0 : policyItem.payload) || {},
      first_name = _ref2.first_name,
      last_name = _ref2.last_name;

  policyItem.policyNumber = policyNumber;
  policyItem.policyStartDateText = !!activeDate ? formatCommonDateStr(activeDate) : 'N/A';
  policyItem.policyEndDateText = !!expirationDate ? formatCommonDateStr(expirationDate) : 'N/A';
  policyItem.fullName = "".concat(first_name, " ").concat(last_name);
  policyItem.insurerText = (_PROVIDER_SOURCE_LIST = PROVIDER_SOURCE_LIST().find(function (item) {
    return item.value === providerCode;
  })) === null || _PROVIDER_SOURCE_LIST === void 0 ? void 0 : _PROVIDER_SOURCE_LIST.displayName;
  policyItem.createdAtText = !!createdAt ? formatCommonDateStr(createdAt) : 'N/A';
  return policyItem;
};
export var handlePolicyQuoteDataWithPolicyDetailInfo = function handlePolicyQuoteDataWithPolicyDetailInfo(policyDetailInfo) {
  var _PROVIDER_SOURCE_LIST2;

  var _ref3 = policyDetailInfo || {},
      providerCode = _ref3.providerCode,
      createdAt = _ref3.createdAt,
      policyNumber = _ref3.policyNumber,
      activeDate = _ref3.activeDate,
      expirationDate = _ref3.expirationDate,
      cancellationDate = _ref3.cancellationDate;

  var _ref4 = (policyDetailInfo === null || policyDetailInfo === void 0 ? void 0 : policyDetailInfo.payload) || {},
      first_name = _ref4.first_name,
      last_name = _ref4.last_name,
      scheduled_cancel_at = _ref4.scheduled_cancel_at;

  policyDetailInfo.policyNumber = policyNumber;
  policyDetailInfo.policyStartDateText = !!activeDate ? formatCommonDateStr(activeDate) : '';
  policyDetailInfo.policyEndDateText = !!expirationDate ? formatCommonDateStr(expirationDate) : '';
  policyDetailInfo.fullName = "".concat(first_name, " ").concat(last_name);
  policyDetailInfo.insurerText = (_PROVIDER_SOURCE_LIST2 = PROVIDER_SOURCE_LIST().find(function (item) {
    return item.value === providerCode;
  })) === null || _PROVIDER_SOURCE_LIST2 === void 0 ? void 0 : _PROVIDER_SOURCE_LIST2.displayName;
  policyDetailInfo.createdAtText = !!createdAt ? formatCommonDateStr(createdAt) : '';
  policyDetailInfo.cancellationDateText = !!cancellationDate ? formatCommonDateStr(cancellationDate) : '';
  policyDetailInfo.cancellationRequestDateText = !!scheduled_cancel_at ? formatCommonDateStr(scheduled_cancel_at) : '';
  return policyDetailInfo;
};